export default __webpack_public_path__ + "static/media/uptok.a3288b3a.png";